/*
    Comms
*/
export const MARKETING_NUMBER_PROVISIONED = 'Text Marketing Number Provisioned';
export const TEXT_BEGIN_MARKETING_NUMBER_PROVISIONING = 'Text Marketing Provisioning Started';
export const TEXT_COMPLETE_MARKETING_NUMBER_PROVISIONING = 'Text Marketing Number Provisioned';
export const TEXT_MARKETING_DISCOVERED = 'Text Marketing Discovered';
export const TEXT_MARKETING_AUTOMATION_CREATED = 'Added Text Automation';
export const TEXT_MARKETING_AUTOMATION_PRICING_ALERT_CLOSED = 'Closed pricing alert';
export const KMN_TEMPLATE_CHOSEN = 'KMN Template Chosen';
export const KMN_TEMPLATE_CREATED = 'KMN Template Created';
export const KMN_TEMPLATE_DELETED = 'KMN Template Deleted';
export const MANAGE_KMN_TEMPLATES = 'Manage KMN Templates';
export const TEXT_BROADCAST_CREATED = 'Text Broadcast Created';
export const TEXT_BROADCAST_WRITTEN = 'Text Broadcast Written';
export const TEXT_BROADCAST_SENT = 'Text Broadcast Sent';
export const KMN_BROADCAST_LIMIT_EXCEEDED = 'KMN Broadcast limit exceeded';
export const TOGGLED_CONTACT_RECORD = 'toggled contact record layout';

/* Contacts */
export const CONTACT_LIMIT_ALERT = 'Contact limit alert';

/* Marketing Sites */
export const MARKETING_SITE_SHARE_FEEDBACK_DISMISSED = 'Landing Pages Feedback modal dismissed';

/* Subscription Management */
export const SUBSCRIPTION_MANAGEMENT_QUICK_ADD = 'Subscription Management Quick Add';
export const PRO_SERVICES = 'Pro Services';
